<template>
  <div
      class="footer"
  >
    <v-btn text small @click="$emit('open-close-chat')" elevation="0">{{ $t('msg.help') }}</v-btn>
    <span>uday.club &copy; {{ year }}</span>
  </div>
</template>

<script>
  export default {
    data: () => ({
      year: new Date().getFullYear()
    }),
  }
</script>

<style lang="scss">
  .footer {
    width: 100%;
    background-color: #f4f5f7 !important;
    font-size: 13px;
    padding: 10px 20px 10px 10px;
    border-top: 1px solid #e7e7e7 !important;
    flex: 0 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .v-btn__content {
      font-weight: normal;
      font-size: 10px;
    }
  }
</style>